import { Cell } from '@vinted/web-ui';
import StackTrace from '../StackTrace';
import { jsx as _jsx } from "react/jsx-runtime";

const ComponentError = _ref => {
  let {
    error,
    errorInfo
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "u-fill-width u-fill-height u-flexbox",
    children: /*#__PURE__*/_jsx(Cell, {
      theme: "muted",
      title: "Component Error",
      children: /*#__PURE__*/_jsx("div", {
        className: "u-overflow-hidden",
        children: /*#__PURE__*/_jsx(StackTrace, {
          error: error,
          errorInfo: errorInfo
        })
      })
    })
  });
};

export default ComponentError;